export default {
    props: {
        predicate: Boolean,
        /**
         * Grid instance to get access to the API
         */
        grid: Object,
        /**
         * Defines the selected rows for the bulk action
         */
        rows: Array,
    },
    computed: {
        selectedRowCount() {
            return this.rows.length;
        },
        hasOneRowSelected() {
            return this.rows.length > 0;
        },
    },
    data() {
        return {
            isProcessing: false,
        };
    },
};
